/**
 * tolling-api v2
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ActivityFeeResponseDto {
    type?: ActivityFeeResponseDto.TypeEnum;
    name?: string;
    amount?: number;
}
export namespace ActivityFeeResponseDto {
    export const TypeEnum = {
        TripTollCharge: 'TRIP_TOLL_CHARGE',
        CameraCharge: 'CAMERA_CHARGE',
        ProcessingFee: 'PROCESSING_FEE',
        TransactionFee: 'TRANSACTION_FEE',
    } as const;
    export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
